import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = 'https://www.testometer.in:8084/api';

const AdminLogin = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log('Attempting to login with:', { username: formData.username, password: '***' });
      
      const response = await axios.post(`${API_BASE_URL}/admin/login`, formData);
      
      console.log('Login response:', response.data);
      
      if (response.data.success) {
        // Store token and admin info in localStorage
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('adminInfo', JSON.stringify(response.data.admin));
        onLoginSuccess(response.data.admin, response.data.token);
      } else {
        setError(response.data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        statusText: error.response?.statusText
      });
      
      if (error.response) {
        // Server responded with error status
        if (error.response.status === 401) {
          setError('Invalid username or password');
        } else if (error.response.status === 500) {
          setError('Server error. Please try again later.');
        } else {
          setError(error.response.data?.message || `Error ${error.response.status}: ${error.response.statusText}`);
        }
      } else if (error.request) {
        // Request was made but no response received
        setError('Unable to connect to server. Please check if the backend is running.');
      } else {
        // Something else happened
        setError('Login failed: ' + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const testConnection = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/test`);
      console.log('Test connection successful:', response.data);
      alert('✅ Backend connection successful!');
    } catch (error) {
      console.error('Test connection failed:', error);
      alert('❌ Backend connection failed: ' + error.message);
    }
  };

  return (
    <div className="admin-login">
      <div className="container">
        <div className="login-card">
          <div className="login-header">
            <div className="logo">
              <span className="logo-icon">🔐</span>
              <h1>Admin Login</h1>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                className="input-field"
                placeholder="Enter your username"
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                className="input-field"
                placeholder="Enter your password"
                required
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              className={`btn btn-primary login-btn ${loading ? 'loading' : ''}`}
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="spinner"></div>
                  Signing In...
                </>
              ) : (
                'Sign In'
              )}
            </button>
          </form>

          <div className="login-footer">
            {/* <p>Default credentials: admin / admin123</p> */}
            {/* <button 
              onClick={testConnection} 
              className="btn btn-secondary"
              style={{ marginTop: '1rem', fontSize: '0.875rem', padding: '0.5rem 1rem' }}
            >
              🔧 Test Backend Connection
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin; 